import type { Unit } from '../types';

svgUnitCtrl.$inject = ['$state'];

interface SvgUnitCtrlProps {
  state: any;
  publicMode: boolean;
  unit: Unit;
  statusClass: string;
}

export function svgUnitCtrl(this: SvgUnitCtrlProps, $state) {
  const vm = this;

  vm.state = $state;

  switch (vm.unit.status.type) {
    case '1':
      vm.statusClass = vm.publicMode ? 'sold' : 'closed';
      break;
    case '2':
      vm.statusClass = 'free';
      break;
    case '3':
      vm.statusClass = 'reserved';
      break;
    case '4':
      vm.statusClass = 'sold';

      if (Number(vm.unit.is_in_resale)) {
        vm.statusClass = vm.publicMode ? 'free' : 'resale';
      }

      break;
    default:
      vm.statusClass = 'closed';
      break;
  }
}
